import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelpersService } from 'src/core/services/helpers.service';

@Component({
  selector: 'app-modal-sanita-scuole',
  templateUrl: './modal-sanita-scuole.component.html',
  styleUrls: ['./modal-sanita-scuole.component.scss']
})
export class ModalSanitaScuoleComponent implements OnInit {

  @Input() buildings: any[];
  @Input() end: any;
  @Output() selectBuilding: EventEmitter<any> = new EventEmitter();
  @Output() dismissModal: EventEmitter<any> = new EventEmitter();
  public type: string = '';
  public wait = true;

  constructor(private helpersService: HelpersService) { }

  ngOnInit(): void {
    if (this.buildings && this.buildings.length) {
      this.wait = this.buildings.length ? false : true;
    }
  }

  public open(buildings, type) {
    this.buildings = buildings;
    this.type = type;
    this.helpersService.open('modalComponentSS');
  }

}
